import * as React from 'react';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import {
    getAllUpcomingAuctionsUrl,
    getAuctioneerDirectoryUrl,
    getAuctionResultsUrl,
    getAuctionsNearMePageUrl,
} from '@/utils/urls';
import { trackPastAuctionResultsClick } from '@/redux/modules/analytics';
import { useAppDispatch } from '@/redux/hooks';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import Popover from '@liveauctioneers/caterwaul-components/lib/Popover/Popover';
import styled from 'styled-components';
import Text from '@liveauctioneers/caterwaul-components/lib/Text/Text';

const FindAuctions = () => {
    const dispatch = useAppDispatch();
    const track = React.useCallback(() => {
        dispatch(trackPastAuctionResultsClick());
    }, [dispatch]);

    return (
        <Popover
            childrenClickClosesPopover
            disableBottomPlacementFallbacks
            hoverShowDelay={200}
            placement="bottom"
            trigger={
                <StyledTriggerText colorBlue>
                    <FormattedMessage id="find_auctions" />
                    <StyledCaretFAI icon={faCaretDown} />
                </StyledTriggerText>
            }
        >
            <StyledContent>
                <StyledNavigationLink route to={getAllUpcomingAuctionsUrl()}>
                    <FormattedMessage id="auction_calendar" />
                </StyledNavigationLink>
                <StyledNavigationLink route to={getAuctionsNearMePageUrl()}>
                    <FormattedMessage id="auctions_near_me" />
                </StyledNavigationLink>
                <StyledNavigationLink route to={getAuctioneerDirectoryUrl()}>
                    <FormattedMessage id="auction_house_directory" />
                </StyledNavigationLink>
                <StyledNavigationLink onClick={track} route to={getAuctionResultsUrl()}>
                    <FormattedMessage id="past_auction_results" />
                </StyledNavigationLink>
            </StyledContent>
        </Popover>
    );
};

export default React.memo(FindAuctions);

const StyledTriggerText = styled(Text)`
    && {
        text-decoration: none;
        padding: 10px 8px 10px 0;
        cursor: pointer;
        line-height: 33px;

        /* special case, this needs to match the font and size of other navigation. */
        font-family: ${({ theme }) => theme.typography.fontSecondary};

        @media (max-width: 976px) {
            font-size: 14px;
        }
    }
`;

const StyledCaretFAI = styled(FontAwesomeIcon)`
    margin-left: 10px;
    height: 16px;
    width: 10px;
`;

const StyledContent = styled.div`
    display: flex;
    flex-direction: column;
    padding: 10px 0;
`;

const StyledNavigationLink = styled(Link)`
    && {
        /* Link and text don't play well together. OP-621 is to fix that */
        color: ${({ theme }) => theme.colors.grey100};
        cursor: pointer;
        font-family: ${({ theme }) => theme.typography.fontPrimary};
        font-size: 14px;
        letter-spacing: 0.5px;
        line-height: 43px;
        padding: 2px 20px;
        text-align: left;
        text-decoration: none;

        :hover {
            color: ${({ theme }) => theme.colors.blue200};
            background-color: ${({ theme }) => theme.colors.grey500};
        }
    }
`;
